import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {store} from "./store";
import {Provider} from "react-redux";
import {setupAuthInterceptor} from "./utils/authInterceptor";

// Токен теперь имеет срок жизни — при 401 уводим на форму входа,
// иначе пользователь получит ошибку на каждом запросе и не поймёт, что нужно перелогиниться.
setupAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);
